import React from "react";
import { Form, Col, Row, Button, InputGroup } from "react-bootstrap";
import Select from "react-select";
import { FieldArray } from "formik";
import OrderAmountsFieldArrayAdicional from "../../orders/orderAmounts/orderAmountsFieldArrayAdicional.js";
import {
  Panel,
  PanelHeader,
  PanelBody,
} from "../../../../components/panel/panel";
import { useOrderVialContext } from "../../../../context/OrderVialContext.js";
import '../../orders/orderCustom.css';
import { useEffect } from "react";

const PaymentData = ({ values, errors, setFieldValue, setFieldTouched }) => {
  const { orderStatuses } = useOrderVialContext();

  const statusOptions = orderStatuses.map((status) => ({
    value: status,
    label: status,
  }));

  // Calcular costos adicionales y total
  const costosAdicionales = values.montosExtras.reduce((acc, item) => {
    const monto = parseFloat(item.monto_extra_monto);
    return acc + (isNaN(monto) ? 0 : monto);
  }, 0);

  const total = parseFloat(values.subtotal || 0) + costosAdicionales;

  return (
    <>
      <Row className="mb-3">
        <Col md="12">
          <PanelBody>
            <Form.Label>Costos adicionales</Form.Label>
            <div className="col-md-12">
              <div className="table-responsive">
                <FieldArray name="montosExtras">
                  {(arrayHelpers) => (
                    <>
                      <table className="table table-amount">
                        {values.montosExtras && values.montosExtras.length > 0
                          ? values.montosExtras.map((montoExtra, index) => (
                              <OrderAmountsFieldArrayAdicional
                                key={`monto_extra_${index}`}
                                index={index}
                                values={values}
                                errors={errors}
                                arrayHelpers={arrayHelpers}
                                setFieldValue={setFieldValue}
                                setFieldTouched={setFieldTouched}
                              />
                            ))
                          : null}
                      </table>

                      {/* Botón fuera de la tabla */}
                      <div className="d-flex align-items-center justify-content-end mt-2">
                        <button
                          type="button"
                          className="btn btn-success btn-icon btn-circle btn-sm"
                          onClick={() =>
                            arrayHelpers.push({
                              monto_extra_descripcion: "",
                              monto_extra_monto: 0,
                            })
                          }
                        >
                          <i className="fa-solid fa-plus"></i>
                        </button>
                        <span className="ms-2">Agregar Adicional</span>
                      </div>
                    </>
                  )}
                </FieldArray>
              </div>
            </div>
          </PanelBody>
        </Col>
      </Row>

      <Row>
        {/* <Form.Group as={Col} md="4" className="mb-3">
          <Form.Label>Subtotal (Costo del servicio)</Form.Label>
          <Form.Control
            type="number"
            name="subtotal"
            value={values.subtotal}
            onChange={(e) => setFieldValue("subtotal", e.target.value)}
            isInvalid={!!errors.subtotal}
            step="0.01"
            min="0"
          />
          <Form.Control.Feedback type="invalid">
            {errors.subtotal}
          </Form.Control.Feedback>
        </Form.Group> */}

        {/* <Form.Group as={Col} md="4" className="mb-3">
          <Form.Label>Costos Adicionales</Form.Label>
          <Form.Control
            type="text"
            value={costosAdicionales.toFixed(2)}
            disabled
          />
        </Form.Group> */}

        <Form.Group as={Col} md="4" className="mb-3">
          <Form.Label>Total (IVA incluido)</Form.Label>
          <Form.Control type="text" value={total.toFixed(2)} disabled />
        </Form.Group>
      </Row>
      <Row className="mt-4">
        <Form.Group as={Col} md="6">
          <Form.Label>Estatus</Form.Label>
          <Select
            key={values.estatus}
            name="estatus"
            options={statusOptions}
            value={statusOptions.find((opt) => opt.value === values.estatus)}
            onChange={(e) => {
              setFieldTouched("estatus", true);
              setFieldValue("estatus", e.value);
            }}
            isSearchable={false}
            isDisabled={true}
          />
          {errors.estatus && (
            <div className="text-danger mt-1">{errors.estatus}</div>
          )}
        </Form.Group>
      </Row>
    </>
  );
};

export default PaymentData;
